<template>
  <div>
    <!-- <v-progress-circular
      v-if="isLoading"
      indeterminate
      color="primary"
      size="50"
      class="mx-auto my-4"
    ></v-progress-circular> -->
    <div v-if="mails && mails.length">
      <v-list-subheader
        :title="groupTitle"
        style="color: #8e8e93; font-size: 14px; line-height: 24px"
      ></v-list-subheader>

      <v-col
        v-for="mail in filterMails(mails, search)"
        :key="mail.id"
        cols="12"
        class="ma-0 pa-0"
      >
        <v-card elevation="0">
          <v-list :lines="$store.state.isMobile ? 'one' : 'two'">
            <v-list-item @click="openMail(mail)">
              <v-list-item class="ma-0 pb-0">
                <template v-slot:prepend>
                  <v-icon
                    icon="mdi-circle-medium"
                    style="position: absolute; left: -5px"
                    color="#2CA6F7"
                    v-if="mail.flag.isSeen == false"
                  />
                  <v-avatar size="34" color="primary">
                    <img
                      width="34"
                      v-if="mail.icon"
                      :src="mail.icon"
                      alt="Avatar"
                    />
                    <span v-else class="text-h6">U</span>
                  </v-avatar>
                </template>
                <template v-slot:append>
                  <div class="d-flex flex-column">
                    <v-list-item-subtitle
                      style="align-self: end; font-size: 12px"
                    >
                      {{ isTodayOrYesterday ? mail.timeTitle : mail.dateTitle }}
                    </v-list-item-subtitle>

                    <div class="d-flex justify-end align-center">
                      <v-icon v-if="mail.attachment">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 21 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.582 5.69286L6.692 13.2459C6.46775 13.4565 6.28903 13.7109 6.16687 13.9933C6.0447 14.2757 5.98167 14.5802 5.98167 14.8879C5.98167 15.1956 6.0447 15.5 6.16687 15.7824C6.28903 16.0648 6.46775 16.3192 6.692 16.5299C7.15625 16.9666 7.76962 17.2097 8.407 17.2097C9.04438 17.2097 9.65775 16.9666 10.122 16.5299L17.956 9.03186C18.3822 8.63161 18.7219 8.14827 18.9541 7.61166C19.1864 7.07506 19.3062 6.49656 19.3062 5.91186C19.3062 5.32716 19.1864 4.74867 18.9541 4.21206C18.7219 3.67545 18.3822 3.19211 17.956 2.79186C16.156 1.06886 13.238 1.06886 11.438 2.79186L3.489 10.3999C0.837 12.9399 0.837 17.0559 3.489 19.5959C6.141 22.1359 10.443 22.1349 13.096 19.5959L19.5 13.4659"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                        </svg>
                      </v-icon>
                    </div>
                  </div>
                </template>
                <v-list-item-title style="font-size: 16px">
                  {{ mail.fromName }}
                </v-list-item-title>
                <v-list-item-title style="font-size: 14px">
                  {{ mail.subject }}
                </v-list-item-title>
              </v-list-item>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "MailsGroup",
  props: {
    folderId: {
      type: Number,
      required: true,
    },
    login: {
      type: String,
      required: true,
    },
    pass: {
      type: String,
      required: true,
    },
    host: {
      type: String,
      required: true,
    },
    port: {
      type: Number,
      required: true,
    },
    encrypt: {
      type: String,
      default: "ssl",
    },
    type: {
      type: String,
      default: "password",
    },

    groupType: {
      type: String,
      required: true, // 'today', 'yesterday', 'week'
    },
    search: {
      type: String,
      required: false,
    },
    openMail: {
      type: Function,
      required: true,
    },
    setIsLoading: {
      type: Function,
      required: true,
    },
    filterMails: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      mails: [],
      isLoading: false,
      intervalId: null,
      currentRequestToken: 0,
    };
  },
  computed: {
    groupTitle() {
      switch (this.groupType) {
        case "today":
          return "Сегодня";
        case "yesterday":
          return "Вчера";
        case "week":
          return "За последнюю неделю";
        default:
          return "";
      }
    },
    isTodayOrYesterday() {
      return this.groupType === "today" || this.groupType === "yesterday";
    },
  },

  watch: {
    folderId: {
      immediate: true,
      handler() {
        this.mails = [];
        this.fetchMails();
        this.stopAutoUpdate();
        this.startAutoUpdate();
      },
    },
  },

  methods: {
    async fetchMails(isUpdate) {
      //   this.isLoading = true;

      const requestToken = ++this.currentRequestToken;
      if (!isUpdate) {
        this.setIsLoading(true);
      }

      const paramsMap = {
        today: "getAllMailsFolderToday",
        yesterday: "getAllMailsFolderYesterday",
        week: "getAllMailsFolderWeek",
      };
      const params = paramsMap[this.groupType];

      try {
        const formData = new FormData();
        formData.append("params", params);
        formData.append("login", this.login);
        formData.append("password", this.pass);
        formData.append("host", this.host);
        formData.append("type", this.type);
        formData.append("port", this.port);
        formData.append("encrypt", this.encrypt);
        formData.append("folder_number", this.folderId);

        const response = await axios.post(
          "https://email.rcgit.ru/imap/",
          formData
        );
        console.log(response);
        if (requestToken !== this.currentRequestToken) {
          return;
        }
        const existingMails = this.mails;
        const newMails = response.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );

        const uniqueNewMails = newMails.filter(
          (newMail) =>
            !existingMails.some(
              (existingMail) => existingMail.id === newMail.id
            )
        );
        console.log(uniqueNewMails);
        this.mails = [...this.mails, ...uniqueNewMails].sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
      } catch (error) {
        console.error("Ошибка при получении писем:", error);
      } finally {
        this.setIsLoading(false);
      }
    },

    // groupMessagesByDate(messages) {
    //   const today = new Date();
    //   const yesterday = new Date();
    //   yesterday.setDate(today.getDate() - 1);
    //   const lastWeek = new Date();
    //   lastWeek.setDate(today.getDate() - 7);

    //   const groupedMessages = {
    //     today: { title: "Сегодня", mails: [] },
    //     yesterday: { title: "Вчера", mails: [] },
    //     lastWeek: { title: "За последнюю неделю", mails: [] },
    //     older: { title: "Больше месяца назад", mails: [] },
    //   };

    //   messages.forEach((message) => {
    //     const messageDate = new Date(message.date);
    //     if (messageDate.toDateString() === today.toDateString()) {
    //       groupedMessages.today.mails.push(message);
    //     } else if (messageDate.toDateString() === yesterday.toDateString()) {
    //       groupedMessages.yesterday.mails.push(message);
    //     } else if (messageDate > lastWeek) {
    //       groupedMessages.lastWeek.mails.push(message);
    //     } else {
    //       groupedMessages.older.mails.push(message);
    //     }
    //   });

    //   return groupedMessages;
    // },

    startAutoUpdate() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        if (this.groupType === "today") {
          this.fetchMails(true);
        }
      }, 10000);
    },
    stopAutoUpdate() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
  },
  mounted() {
    if (this.groupType === "today") {
      this.startAutoUpdate();
    }
  },
  beforeUnmount() {
    this.stopAutoUpdate();
  },
};
</script>
<style>
.v-list-item__prepend > .v-badge ~ .v-list-item__spacer,
.v-list-item__prepend > .v-icon ~ .v-list-item__spacer,
.v-list-item__prepend > .v-tooltip ~ .v-list-item__spacer {
  width: 12px;
}

.active-icon svg path {
  fill: #2ca6f7 !important;
}

.v-icon svg path div {
  stroke: #a6acb5;
  fill: #a6acb5;
}

.active-item {
  background-color: #f0f8ff;
}
</style>
